import { Component } from '@angular/core';

type PricingTier = 'iniciante' | 'padrao' | 'avancado';

interface FeatureGroup {
  title: string;
  iconClass: string;
  items: string[];
}

interface PlanDefinition {
  name: string;
  price: number;
  period: string;
  adhesion: number;
  adhesionInstallments: string;
  installments: string;
  highlight: boolean;
  savings: string | null;
}

interface AddonDefinition {
  name: string;
  price: number;
  desc?: string;
  features?: string[];
}

interface ActivePlan extends PlanDefinition {
  anchorPrice: number | null;
  originalPrice: number;
}

@Component({
  selector: 'app-proposta-comercial',
  templateUrl: './proposta-comercial.component.html',
  styleUrls: ['./proposta-comercial.component.scss']
})
export class PropostaComercialComponent {
  readonly featureGroups: FeatureGroup[] = [
    {
      title: 'Cardápio Digital',
      iconClass: 'mdi mdi-cellphone',
      items: [
        'Cardápio Interativo (Link Próprio)',
        'Pedidos via QR Code na Mesa',
        'Link na Bio (Compra sem digitar dados)',
        "Botão 'Pedir Novamente' (Compra em 1 clique)",
      ]
    },
    {
      title: 'Vendas e MarketPlace',
      iconClass: 'mdi mdi-store',
      items: [
        'Módulo PDV (Frente de Caixa Completo)',
        'Relatórios de Abertura e Fechamento',
        'Sangria e Suprimento de Caixa',
        'Integração Oficial com iFood',
        'Extensão WhatsApp Web para Tirar Pedidos',
      ]
    },
    {
      title: 'Logística & Entregas',
      iconClass: 'mdi mdi-truck-delivery',
      items: [
        'Controle de Entregas (cadastro de motoboys)',
        'Associar motoboy ao pedido',
        'Envio de Mensagem para o motoboy',
      ]
    },
    {
      title: 'Módulo Garçom',
      iconClass: 'mdi mdi-silverware-fork-knife',
      items: [
        'App Exclusivo para Tirar Pedidos na Mesa',
        'Envio Direto e Automático para a Cozinha',
        'Acompanhamento de Status e Controlo de Mesas',
        'Fechamento de Conta Rápido',
      ]
    },
    {
      title: 'Marketing e Aumentar Recompras',
      iconClass: 'mdi mdi-bullhorn',
      items: [
        'Recuperação de Carrinhos Abandonados',
        'Disparo de Mensagens (Remarketing)',
        'Fidelidade VIP (Cashback e Selos)',
        'Cupons e Promoções automáticas',
        'CRM (Gestão da Base de Clientes)',
        'Relatório de Produtos Campeões',
      ]
    },
    {
      title: 'Atendimento & Relacionamento',
      iconClass: 'mdi mdi-message-text-outline',
      items: [
        'Mia: IA que Atende e Vende 24h',
        'Notificação de status de pedidos',
        'Avaliação de Pedidos',
      ]
    },
    {
      title: 'Gestão & Operação',
      iconClass: 'mdi mdi-view-dashboard-outline',
      items: [
        'Dashboards Financeiros (Vendas do Dia)',
        'Controle de Estoque Avançado',
        'Impressão Automática Térmica',
        'KDS (Tela de Produção)',
      ]
    },
    {
      title: 'Cupom Fiscal',
      iconClass: 'mdi mdi-receipt',
      items: [
        'Emissão de Notas Fiscais (NFC-e)',
        'Relatório de Notas Emitidas',
        'Emissão Manual ou Automática por Pedido',
      ]
    },
    {
      title: 'Garantia & Suporte',
      iconClass: 'mdi mdi-lifebuoy',
      items: [
        'Suporte Humano via WhatsApp',
        'Implantação Express (48h úteis após dados)',
      ]
    }
  ];

  readonly plans: PlanDefinition[] = [
    { name: 'Mensal', price: 180, period: 'mês', adhesion: 150, adhesionInstallments: '12x de R$ 12,50', installments: '1x', highlight: false, savings: null },
    { name: 'Trimestral', price: 175, period: 'mês', adhesion: 125, adhesionInstallments: '12x de R$ 10,41', installments: '3x', highlight: false, savings: null },
    { name: 'Semestral', price: 165, period: 'mês', adhesion: 100, adhesionInstallments: '12x de R$ 8,33', installments: '6x', highlight: false, savings: null },
    { name: 'Anual', price: 150, period: 'mês', adhesion: 0, adhesionInstallments: '', installments: '12x', highlight: true, savings: 'R$ 560/ano' },
  ];

  readonly addons: AddonDefinition[] = [
    { name: 'Domínio Próprio', price: 29.9, desc: 'seusite.com.br' },
    {
      name: 'Agendamento de Pedidos',
      price: 29.9,
      features: [
        'Agendamento de pedidos',
        'Relatório de pedidos agendados',
        'Ver pedidos por data'
      ]
    },
    { name: 'QR Code Na Mesa', price: 29.9, desc: 'Pedidos de autoatendimento' },
    { name: 'Nota Fiscal (NFC-e)', price: 49.9, desc: 'Emissão automática de cupom fiscal' },
    { name: 'Módulo Garçom', price: 29.9, desc: 'App para garçom tirar pedidos na mesa' },
  ];

  readonly guarantees: string[] = [
    'Sem taxa por pedido',
    'Sem cobrança de PIX do cliente',
    'Sem aumento surpresa de preço',
    'Sem fidelidade forçada — cancele quando quiser',
    'Seus dados são SEUS — nunca compartilhamos com iFood',
  ];

  readonly comparisonData: Array<[string, boolean, boolean]> = [
    ['Preço fixo garantido', true, false],
    ['Sem taxa no PIX do cliente', true, false],
    ['Seus dados ficam com VOCÊ', true, false],
    ['Nota Fiscal / NFC-e', true, false],
    ['Controle de Estoque', true, false],
    ['KDS (Tela de Produção)', true, false],
    ['PDV completo', true, false],
    ['Cancelamento sem burocracia', true, false],
    ['Reclame Aqui limpo', true, false],
    ['Suporte WhatsApp (Seg-Sex 23h / FDS 21h)', true, false],
    ['Integração iFood', true, true],
  ];

  selectedPlan = 3;
  selectedAddons = this.addons.map(() => false);
  exemptAddons = this.addons.map(() => false);
  showComparison = false;
  extraAdjustment = 0;
  adjustmentLabel = 'Ajuste Comercial Extra';
  showAdjustmentInput = false;
  showPix = false;
  pixPercent = 6.5;
  cartOverrides: { installments?: string; price?: number; adhesion?: number } = {};
  isAnniversaryPromo = false;

  clientName = 'Fernando';
  companyName = 'Dog Paulista';
  location = 'João Pessoa - PB';
  proposalDate = 'Março 2026';
  isEditingHeader = false;
  pricingTier: PricingTier = 'padrao';

  isEditingFeatures = false;
  hiddenFeatures: Record<string, boolean> = {};

  readonly tierPrices: Record<PricingTier, number[]> = {
    iniciante: [149.9, 139.9, 134.9, 124.9],
    padrao: [179.9, 164.9, 149.9, 134.9],
    avancado: [199.9, 179.9, 164.9, 149.9]
  };

  readonly tierAdhesions: Record<PricingTier, number[]> = {
    iniciante: [99.9, 49.9, 0, 0],
    padrao: [149.9, 99.9, 49.9, 0],
    avancado: [199.9, 149.9, 99.9, 0]
  };

  readonly promoPrices: Record<PricingTier, number[]> = {
    iniciante: [129.9, 119.9, 114.9, 104.9],
    padrao: [169.9, 154.9, 139.9, 119.9],
    avancado: [179.9, 159.9, 144.9, 129.9]
  };

  get activePlans(): ActivePlan[] {
    return this.plans.map((plan, i) => {
      const currentTierBase = this.tierPrices[this.pricingTier][i];
      const currentTierPromo = this.promoPrices[this.pricingTier][i];
      const currentAdhesion = this.tierAdhesions[this.pricingTier][i];
      const price = this.isAnniversaryPromo ? currentTierPromo : currentTierBase;
      const basePrice = this.isAnniversaryPromo ? this.promoPrices[this.pricingTier][0] : this.tierPrices[this.pricingTier][0];
      const planYearlyCost = (price * 12) + currentAdhesion;
      const baseYearlyCost = (basePrice * 12) + this.tierAdhesions[this.pricingTier][0];
      const savingsVal = baseYearlyCost - planYearlyCost;
      const premiumBasePrice = this.tierPrices.avancado[i];
      const anchorPrice = price < premiumBasePrice ? premiumBasePrice : null;

      return {
        ...plan,
        price,
        anchorPrice,
        originalPrice: currentTierBase,
        adhesion: currentAdhesion,
        adhesionInstallments: currentAdhesion > 0
          ? `12x de R$ ${this.formatCurrency(currentAdhesion / 12)}`
          : '',
        savings: savingsVal > 0 && plan.name === 'Anual'
          ? `R$ ${this.formatCurrency(savingsVal)}/ano`
          : null
      };
    });
  }

  get currentPlan(): ActivePlan {
    return this.activePlans[this.selectedPlan];
  }

  get activeInstallments(): string {
    return this.cartOverrides.installments !== undefined
      ? this.cartOverrides.installments
      : this.currentPlan.installments.replace('x', '');
  }

  get activePrice(): number {
    return this.cartOverrides.price !== undefined
      ? this.cartOverrides.price
      : this.currentPlan.price;
  }

  get activeAdhesion(): number {
    return this.cartOverrides.adhesion !== undefined
      ? this.cartOverrides.adhesion
      : this.currentPlan.adhesion;
  }

  get theoreticalAddonTotal(): number {
    return this.addons.reduce((sum, addon, index) => sum + (this.selectedAddons[index] ? addon.price : 0), 0);
  }

  get originalSubtotal(): number {
    return this.currentPlan.originalPrice + this.theoreticalAddonTotal;
  }

  get actualAddonTotal(): number {
    return this.addons.reduce((sum, addon, index) => {
      if (!this.selectedAddons[index] || this.exemptAddons[index]) {
        return sum;
      }

      return sum + addon.price;
    }, 0);
  }

  get prePixMonthlyTotal(): number {
    return Math.max(0, this.activePrice + this.actualAddonTotal - this.extraAdjustment);
  }

  get pixDiscountValue(): number {
    return this.showPix ? Math.round(this.prePixMonthlyTotal * (this.pixPercent / 100)) : 0;
  }

  get monthlyTotal(): number {
    return this.prePixMonthlyTotal - this.pixDiscountValue;
  }

  get activeInstallmentsNum(): number {
    const parsed = parseInt(this.activeInstallments, 10);
    return Number.isNaN(parsed) ? 1 : parsed;
  }

  get totalUpfront(): number {
    return (this.monthlyTotal * this.activeInstallmentsNum) + this.activeAdhesion;
  }

  get totalNegotiatedDiscount(): number {
    return this.originalSubtotal - this.monthlyTotal;
  }

  get premiumYearlySavings(): number {
    const premiumEquivalentYearlyCost = (this.tierPrices.avancado[this.selectedPlan] + this.theoreticalAddonTotal) * 12 + this.tierAdhesions.avancado[this.selectedPlan];
    const currentYearlyCost = (this.monthlyTotal * 12) + this.activeAdhesion;
    return premiumEquivalentYearlyCost - currentYearlyCost;
  }

  get totalInt(): string {
    return this.monthlyTotal.toFixed(2).split('.')[0];
  }

  get totalDec(): string {
    return this.monthlyTotal.toFixed(2).split('.')[1];
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }

  selectPlan(index: number): void {
    this.selectedPlan = index;
    this.cartOverrides = {};
    this.extraAdjustment = 0;
    this.showPix = false;
  }

  toggleAnniversaryPromo(): void {
    this.isAnniversaryPromo = !this.isAnniversaryPromo;
    this.cartOverrides = {};
    this.extraAdjustment = 0;
    this.showPix = false;
  }

  toggleAddon(index: number): void {
    this.selectedAddons[index] = !this.selectedAddons[index];
  }

  toggleExempt(event: Event, index: number): void {
    event.stopPropagation();
    this.exemptAddons[index] = !this.exemptAddons[index];

    if (this.exemptAddons[index] && !this.selectedAddons[index]) {
      this.selectedAddons[index] = true;
    }
  }

  toggleFeatureVisibility(itemName: string): void {
    this.hiddenFeatures[itemName] = !this.hiddenFeatures[itemName];
  }

  isFeatureVisible(itemName: string): boolean {
    return !this.hiddenFeatures[itemName];
  }

  visibleItems(group: FeatureGroup): string[] {
    return group.items.filter((item) => this.isFeatureVisible(item));
  }

  saveHeader(): void {
    this.isEditingHeader = false;
  }

  setActiveInstallments(value: string): void {
    this.cartOverrides = { ...this.cartOverrides, installments: value };
  }

  setActivePrice(value: string | number | null): void {
    this.cartOverrides = { ...this.cartOverrides, price: this.toNumber(value) };
  }

  setActiveAdhesion(value: string | number | null): void {
    this.cartOverrides = { ...this.cartOverrides, adhesion: this.toNumber(value) };
  }

  setPixPercent(value: string | number | null): void {
    this.pixPercent = this.toNumber(value);
  }

  setExtraAdjustment(value: string | number | null): void {
    this.extraAdjustment = this.toNumber(value);
  }

  formatCurrency(value: number): string {
    return value.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  priceInt(value: number): string {
    return value.toFixed(2).split('.')[0];
  }

  priceDec(value: number): string {
    return value.toFixed(2).split('.')[1];
  }

  discountPercent(plan: ActivePlan): number {
    if (!plan.anchorPrice) {
      return 0;
    }

    return Math.round((1 - plan.price / plan.anchorPrice) * 100);
  }

  addonDescription(addon: AddonDefinition): string {
    if (addon.name !== 'Domínio Próprio') {
      return addon.desc || '';
    }

    const slug = this.companyName
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '');

    return `${slug || 'seusite'}.com.br`;
  }

  private toNumber(value: string | number | null | undefined): number {
    if (value === '' || value === null || value === undefined) {
      return 0;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }
}
